import React, { useState } from "react";
import "./PersonalInfo.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
const ClientDashboardPersonalInfo = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <div className="clientdashboard__personalinfo_section">
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_innersection">
          <div className="clientdashboard__personalinfo_inrsecheader">
            Personal Identity Information
          </div>
          <div className="clientdashboard__personalinfo_inrsecbody">
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Filing Status
                </label>
                <CustomDropdown
                  options={[]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Name
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter Name Here"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Occupation
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Ex: Businessman"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Email ID
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter Your Email"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Timezone
                </label>
                <CustomDropdown
                  options={["Central Standard Time(CST)"]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                  selectedLabel="Central Standard Time(CST)"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  SSN
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="SSN"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Date of Birth
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Anniversary
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Visa Type
                </label>
                <CustomDropdown
                  options={["F1"]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                  selectedLabel="F1"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  First Entry
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_innersection">
          <div className="clientdashboard__personalinfo_inrsecheader">
            Contact Information
          </div>
          <div className="clientdashboard__personalinfo_inrsecbody">
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Phone Number
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter your Number"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Alternate Phone
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter Alternate Number"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Indian Phone
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter your Number"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Mailing Address
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter Your Address"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Apartment
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="#"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  City
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter City Name"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Date of Birth
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  State
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter State Name"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  State
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter State Name"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Zip
                </label>
                <input
                  type="Enter Zip Code"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter State Name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_innersection">
          <div className="clientdashboard__personalinfo_inrsecheader">
            Residential Address(es) during tax year{" "}
            <small>
              [Please list out all the address(es) you stayed at during the tax
              year]
            </small>
          </div>
          <div className="clientdashboard__personalinfo_isec2wrap">
            <div className="clientdashboard__personalinfo_innersection2">
              <div className="clientdashboard__personalinfo_inrsec2header">
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  Tax Year
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  State of Residence
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  From
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  To
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  Option
                </div>
              </div>
              <div className="clientdashboard__personalinfo_inrsec2body">
                {residentialAddresses?.map((item, index) => (
                  <div className="clientdashboard__personalinfo_inrsec2brow">
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      {item?.year}
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="text"
                        placeholder="Enter State Name"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="date"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="date"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <div className="clientdashboard__personalinfo_is2soptions">
                        <div
                          className={`clientdashboard__personalinfo_is2soptplus`}
                          onClick={() => addResidentialAddress(index)}
                        >
                          +
                        </div>
                        <div
                          className={`clientdashboard__personalinfo_is2soptminus  ${
                            residentialAddresses?.length < 2
                              ? "clientdashboard__personalinfo_is2soptdisabled"
                              : ""
                          }`}
                          onClick={() => removeResidentialAddress(index)}
                        >
                          -
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="clientdashboard__personalinfo_checkboxitm">
              <div className="clientdashboard__personalinfo_cbileft">
                Have you worked with more than one employer in 2020?
              </div>
              <div className="clientdashboard__personalinfo_cbiright">
                <span>Yes</span>
                <CustomSwitch onSwitch={() => {}} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_innersection">
          <div className="clientdashboard__personalinfo_inrsecheader">
            Spouse's Identity Information
          </div>
          <div className="clientdashboard__personalinfo_inrsecbody">
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Enter Full Name
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Enter Full Name"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Date of Birth
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Visa Type
                </label>
                <CustomDropdown
                  options={["F1"]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                  selectedLabel="F1"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  First Entry (if any)
                </label>
                <input
                  type="date"
                  className="clientdashboard__personalinfo_inputfield"
                />
              </div>
            </div>
            <div className="clientdashboard__personalinfo_inrsecrow">
              <div className="clientdashboard__personalinfo_inrseccolleft">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Occupation
                </label>
                <input
                  type="text"
                  className="clientdashboard__personalinfo_inputfield"
                  placeholder="Ex: Businessman"
                />
              </div>
              <div className="clientdashboard__personalinfo_inrseccol">
                <label className="clientdashboard__personalinfo_inputlbl">
                  Push Notification
                </label>
                <div className="clientdashboard__personalinfo_radioswrap">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="ssn"
                      control={<Radio />}
                      label="SSN"
                    />
                    <FormControlLabel
                      value="itin"
                      control={<Radio />}
                      label="ITIN"
                    />
                    <FormControlLabel
                      value="applying_itin"
                      control={<Radio />}
                      label="Applying ITIN"
                    />
                    <FormControlLabel
                      value="renewing_itin"
                      control={<Radio />}
                      label="Renewing ITIN"
                    />
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_innersection">
          <div className="clientdashboard__personalinfo_inrsecheader">
            Residential Address(es) during tax year{" "}
            <small>
              [Please list out all the address(es) you stayed at during the tax
              year]
            </small>
          </div>
          <div className="clientdashboard__personalinfo_isec2wrap">
            <div className="clientdashboard__personalinfo_innersection2">
              <div className="clientdashboard__personalinfo_inrsec2header">
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  Tax Year
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  State of Residence
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  From
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  To
                </div>
                <div className="clientdashboard__personalinfo_inrsec2hitem">
                  Option
                </div>
              </div>
              <div className="clientdashboard__personalinfo_inrsec2body">
                {residentialAddresses?.map((item, index) => (
                  <div className="clientdashboard__personalinfo_inrsec2brow">
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      {item?.year}
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="text"
                        placeholder="Enter State Name"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="date"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <input
                        type="date"
                        className="clientdashboard__personalinfo_is2ifield"
                      />
                    </div>
                    <div className="clientdashboard__personalinfo_inrsec2bitem">
                      <div className="clientdashboard__personalinfo_is2soptions">
                        <div
                          className={`clientdashboard__personalinfo_is2soptplus`}
                          onClick={() => addResidentialAddress(index)}
                        >
                          +
                        </div>
                        <div
                          className={`clientdashboard__personalinfo_is2soptminus  ${
                            residentialAddresses?.length < 2
                              ? "clientdashboard__personalinfo_is2soptdisabled"
                              : ""
                          }`}
                          onClick={() => removeResidentialAddress(index)}
                        >
                          -
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="clientdashboard__personalinfo_checkboxitm2">
              <div className="clientdashboard__personalinfo_cbicbox">
                {" "}
                <Checkbox
                  defaultChecked
                  sx={{
                    "&.Mui-checked": {
                      color: "rgba(29, 66, 102, 1)",
                    },
                  }}
                />
              </div>
              <div className="clientdashboard__personalinfo_cbirttxt">
                I declare that the information in this application is true and
                correct
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="clientdashboard__personalinfo_wrapper">
        <div className="clientdashboard__personalinfo_bottombtns">
          <button className="clientdashboard__personalinfo_bottombtn1">
            Save
          </button>
          <button className="clientdashboard__personalinfo_bottombtn2">
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardPersonalInfo;
